export default "__VITE_ASSET__Gzzt2JDd__"